const getUrlFormatSlugs = require('./slugs');
const escapeForUrl = require('./escape');

function composeUrlWithFormat(entry, urlFormat, prefixSlash=true) {
  if (!urlFormat) return '';

  let slugs = getUrlFormatSlugs(urlFormat);
  let url = urlFormat;

  slugs.forEach(slug => {
    url = url.replace(`\{\{${slug}\}\}`, escapeForUrl(entry[slug]));
  });

  if (prefixSlash) return `/${url}`;

  return url;
}

module.exports = composeUrlWithFormat;
